export default {"src":"/_next/static/media/logo-hornet.e726fd3e.svg","height":56,"width":296,"blurWidth":0,"blurHeight":0};